(function init() {
  angular.module('app').controller('host.views.debugTools.addHubFieldsToServiceRequest.modal', [
    '$uibModalInstance',
    'abp.services.app.debugTool',
    function controller($uibModalInstance, debugToolSvc) {
      const vm = this;
      vm.saving = 0;

      vm.cancel = cancel;
      vm.confirm = confirm;

      vm.serviceRequestId = '';
      vm.caseId = '';
      vm.hubPatientId = '';
      vm.hubPolicyId = '';

      function cancel() {
        $uibModalInstance.dismiss();
      }

      function confirm() {
        vm.saving += 1;

        const input = {
          serviceRequestId: vm.serviceRequestId,
          caseId: vm.caseId,
          hubPatientId: vm.hubPatientId,
          hubPolicyId: vm.hubPolicyId,
        };

        debugToolSvc
          .addHubFieldsToHubServiceRequest(input)
          .success(() => {
            abp.notify.info('Added inputted fields to Hub Service Request');
          })
          .finally(() => {
            vm.saving -= 1;
            vm.serviceRequestId = '';
            vm.caseId = '';
            vm.hubPatientId = '';
            vm.hubPolicyId = '';
          });
      }
    },
  ]);
})();
